/**
 * There is known bug where it is only possible to pass 32bit int
 * as a timeout value to window.setTimeout or window.setInterval functions
 *
 * If value is larger than this, setTimeout or window.setInterval will be executed immediately
 *
 * Read more here (setTimeout): https://nodejs.org/api/timers.html
 * @param timeout
 */
export function safeTimeout(timeout: number) {
  // Max 32bit int
  const maxDelay = 2147483647;

  return Math.min(timeout, maxDelay);
}
